import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { rememberSuspending3qo0upgbry9b as rememberSuspending } from '../../../../../../../reactive/com/lightningkite/reactive/core/RememberSuspending.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  forEachAnimated1m511890zq8f5 as forEachAnimated,
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../theming/colorManagement.mjs';
import {
  title1ahgushtajx2d as title,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  title1nssp3ryhwuqj as title_0,
  body3i5t0n7zprpqb as body,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
} from '../../../theming/Titles.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../nav/AppDimensions.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { PaymentMethod1x8gg38hdlghq as PaymentMethod } from '../../../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import {
  inlineKeyString1hdvsz76w276 as inlineKeyString,
  htmlKeyString3qkhbon8qnk4f as htmlKeyString,
} from '../../keyValue.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  SecondaryButtonSemantic_getInstance1ksz6yxlolvnl as SecondaryButtonSemantic_getInstance,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
} from '../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  navigateOrDialog1m0cnx3luzasq as navigateOrDialog,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../../nav/crowpay.mjs';
import { awaitSuspendingfmims6z9kmaq as awaitSuspending } from '../../../../utils/utils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  PayRequested65fjypdtje6w as PayRequested,
  MakePaymentInfoBandaidDialog18vq2rlet73fk as MakePaymentInfoBandaidDialog,
} from '../../../dialogs/MakePaymentDialog.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../sdk/UserSession.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { Accept733y3zepx42g as Accept } from '../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { serializable2l0a6bc0gtxdw as serializable } from '../../../../../../../crowpay-shared/com/crowpay/completionResponse/serialization.mjs';
import {
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  LineItem2rt64afaiyloc as LineItem,
} from '../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { Companion_instance3euo5q27joywz as Companion_instance } from '../work/scope/LineItemCompletionForm.mjs';
import {
  first58ocm7j58k3q as first,
  toSet2orjxp16sotqu as toSet,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { repeatForScopeSets2sd4ktutrrxkj as repeatForScopeSets } from '../../../../utils/actions.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { ScopeSetReviewDialog3daipl4340b3e as ScopeSetReviewDialog } from '../../../dialogs/ScopeSetReviewDialog.mjs';
import { ProjectCompleteRequestDetails1r4j7qa671vek as ProjectCompleteRequestDetails } from '../../../dialogs/BasicFlowForms.mjs';
import { ClientPaymentInfo323a5wacn9ntp as ClientPaymentInfo } from '../../../screens/client/ClientProject.mjs';
import { CollectFundsThroughPhysicalCheckDialog3f44xr2mvj2de as CollectFundsThroughPhysicalCheckDialog } from '../../../dialogs/CollectFunds.mjs';
import { requestFundsDialog11j6g5n16g4u9 as requestFundsDialog } from '../../../dialogs/requestFunds.mjs';
import {
  LineItemState_NotStarted_getInstance3brd4lyoananz as LineItemState_NotStarted_getInstance,
  ProjectState_WaitingApproval_getInstance1ditr18fxhnoh as ProjectState_WaitingApproval_getInstance,
  ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance,
  ProjectState_InProgress_getInstance2qplvnabv8loq as ProjectState_InProgress_getInstance,
  ProjectState_RequestingComplete_getInstance29ba44myrjzuw as ProjectState_RequestingComplete_getInstance,
  ProjectState_Complete_getInstance2ov0hpwbwxocu as ProjectState_Complete_getInstance,
  ProjectState_Accepted_getInstance2l1kftynf92aa as ProjectState_Accepted_getInstance,
  ProjectState_PendingStart_getInstance2dqkzmcm0blyg as ProjectState_PendingStart_getInstance,
  ProjectState_SubstantialCompletion_getInstance3e5twdtenc1l1 as ProjectState_SubstantialCompletion_getInstance,
} from '../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { StartWorkItemsDialogs82uh5psoxv6 as StartWorkItemsDialog } from '../../../dialogs/StartWorkItemsDialog.mjs';
import { JumpTo_getInstance3ru9x2o8nieur as JumpTo_getInstance } from '../../../../utils/JumpTo.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { KtList3hktaavzmj137 as KtList } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { RequestFinalCompletionDialog3h3fcreklk22e as RequestFinalCompletionDialog } from '../../../dialogs/RequestSignOffDialog.mjs';
import { Companion_instance2o1tmep3w0ant as Companion_instance_0 } from './concerns/IncidentReportForm.mjs';
import {
  ProjectLens_Preview_getInstance1ljkez32qkuib as ProjectLens_Preview_getInstance,
  Buttons_instancevdnfm4kr7aly as Buttons_instance,
  ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance,
  ProjectLens_Contractor_getInstance3hm6gxlnsv3ks as ProjectLens_Contractor_getInstance,
  WorkSection_Scope_getInstance24nu4pcr0fu0d as WorkSection_Scope_getInstance,
  ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance,
  ActionImportance_Critical_getInstance3s0xptbpomhhd as ActionImportance_Critical_getInstance,
} from '../../../screens/common/ProjectView.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance_1,
  MonetaryValue__compareTo_impl_w7ul1r2xnp6r3vvhd1h as MonetaryValue__compareTo_impl_w7ul1r,
} from '../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { color1u2lxyvdop1o6 as color } from '../work/payApps/data.mjs';
import {
  banners2ndq1wx79ibxx as banners,
  renderBannersNonDismissable3209fu6o2rf9p as renderBannersNonDismissable,
} from '../../../../utils/Banner.mjs';
import {
  ButtonActionqmmxsu493eh2 as ButtonAction,
  Companion_instance1hgjusdx1kcma as Companion_instance_2,
  applyActionFormatting3qxwpgmo0ne4m as applyActionFormatting,
  button2ojurxuym14mn as button,
} from '../../../../utils/ButtonAction.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  acceptActionName1soryjzupmune as acceptActionName,
  acceptConfirmationText15yt66nimg6we as acceptConfirmationText,
} from '../../../../extensions/CompletionResponse.ext.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { acceptFinalCompletion1zm28w35ed7aq as acceptFinalCompletion } from '../actionBar.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { set_value1vvx5pkb20ebv as set_value } from '../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { SetupCustomerMethodDialog2y75086l50hfg as SetupCustomerMethodDialog } from '../../../dialogs/SetupCustomerMethodDialog.mjs';
import { dialog2nk0sz8wudj8p as dialog } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from '../../../dialogs/GenericDialog.mjs';
import { GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog } from '../../../dialogs/GenericConfirmationDialog.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { LineItemDetailsPage1m0bbf89e2gid as LineItemDetailsPage } from '../work/scope/LineItemDetailsPage.mjs';
import { toDoSection277aoqfqgiijq as toDoSection } from '../../../theming/banners.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ToDoActionClass;
function ToDoAction() {
  if (ToDoActionClass === VOID) {
    class $ {
      constructor(name, color, banners, actions) {
        this.lgx_1 = name;
        this.mgx_1 = color;
        this.ngx_1 = banners;
        this.ogx_1 = actions;
      }
      toString() {
        return 'ToDoAction(name=' + this.lgx_1 + ', color=' + this.mgx_1.toString() + ', banners=' + toString(this.ngx_1) + ', actions=' + toString(this.ogx_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.lgx_1);
        result = imul(result, 31) + this.mgx_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.ngx_1) | 0;
        result = imul(result, 31) + hashCode(this.ogx_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ToDoAction()))
          return false;
        if (!(this.lgx_1 === other.lgx_1))
          return false;
        if (!this.mgx_1.equals(other.mgx_1))
          return false;
        if (!equals(this.ngx_1, other.ngx_1))
          return false;
        if (!equals(this.ogx_1, other.ogx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ToDoAction');
    ToDoActionClass = $;
  }
  return ToDoActionClass;
}
function calculateTodos(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  return rememberSuspending(VOID, VOID, VOID, calculateTodos$slambda_0(_this__u8e3s4, writer));
}
function projectToDos(_this__u8e3s4, writer) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  var tmp = sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(15));
  var tmp_0 = view.kbb(tmp, shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(_this__u8e3s4.hgj_1).i1()));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  var tmp_1 = get_centered(view_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.zbm(true);
  var tmp_2 = colored(view_1, AppColors_getInstance().ffz_1.aga_1);
  view_1.lbb(tmp_2, title(view_1, projectToDos$lambda));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_2 = view_1.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
  view_1.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = "You're all caught up with To-Do's right now. Orange activity icon will display when you have pending To-Do's.";
  var tmp_3 = view_2.vb5_1;
  var tmp_4;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_4 = '\xA0';
  } else {
    tmp_4 = value;
  }
  tmp_3.hbu(tmp_4);
  view_2.dbs(Align_Center_getInstance());
  view_1.hbb(p_2, view_2);
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_1, view_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  var tmp_5 = shownWhen(view, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.daj(_this__u8e3s4.hgj_1).i1();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.zbm(true);
  view_3.bb9(get_AppDimensions().zg1_1);
  forEachAnimated(view_3, _this__u8e3s4.hgj_1, VOID, projectToDos$lambda_0);
  view.hbb(p_3, view_3);
  view.lbb(tmp_5, view_3);
  writer.hbb(p, view);
  return view;
}
function calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, name, color, banners, actions) {
  banners = banners === VOID ? emptyList() : banners;
  actions = actions === VOID ? emptyList() : actions;
  allToDos.v(new (ToDoAction())(name, color, banners, actions));
}
function *_generator_invoke__zhh2q8($this, $this$ButtonAction, $completion) {
  var tmp = $this.pgx_1.xgl($this.qgx_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var calculateTodos$slambda$slambda$slambdaClass;
function calculateTodos$slambda$slambda$slambda() {
  if (calculateTodos$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.rgx_1 = $this_calculateTodos;
      }
      sgx($this$SetupCustomerMethodDialog, it, $completion) {
        this.rgx_1.xgi_1.qaq();
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.sgx(tmp, p2 instanceof PaymentMethod() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    calculateTodos$slambda$slambda$slambdaClass = $;
  }
  return calculateTodos$slambda$slambda$slambdaClass;
}
function calculateTodos$slambda$slambda$slambda_0($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda$slambda())($this_calculateTodos);
  var l = ($this$SetupCustomerMethodDialog, it, $completion) => i.sgx($this$SetupCustomerMethodDialog, it, $completion);
  l.$arity = 2;
  return l;
}
function calculateTodos$slambda$slambda$lambda($this$dialog, close) {
  var tmp = $this$dialog.kbb(get_centered($this$dialog), sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_rem(50)));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$dialog.pc());
  var tmp0_elvis_lhs = $this$dialog.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$dialog : tmp0_elvis_lhs;
  $this$dialog.gbb(p, view);
  view.zbm(true);
  view.bb9(get_AppDimensions().zg1_1);
  title_0(view, 'More Info');
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(true);
  body(view_0, 'Connecting your account ensures that all project funds are securely managed within Stoze\u2019s escrow system. Here\u2019s how your money is protected:');
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  inlineKeyString(view_1, 'FDIC Insurance', 'All funds are held in FDIC-insured accounts at Cache Valley Bank, providing protection up to $250,000 per depositor, per institution');
  view_0.hbb(p_1, view_1);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.gbb(p_2, view_2);
  view_2.lba(view_2.qb6_1.abf(BodySemantic_getInstance()));
  inlineKeyString(view_2, 'Additional Security for Higher Balances', 'For projects exceeding $250,000, Stoze automatically distributes funds across multiple accounts with partnered banks to maintain full insurance coverage.');
  view_0.hbb(p_2, view_2);
  body(view_0, 'Stoze\u2019s escrow system is compliant with all relevant escrow regulations, ensuring that your funds are secure, traceable, and only released according to the agreed-upon terms. You can connect your account with confidence, knowing your money is fully protected.');
  view.hbb(p_0, view_0);
  var tmp_0 = view.kbb(get_atStart(view), get_primaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  specCenteredText(view_3, 'Close');
  onClick(view_3, VOID, VOID, calculateTodos$slambda$slambda$lambda$slambda_0(close));
  view.hbb(p_3, view_3);
  view.lbb(tmp_0, view_3);
  $this$dialog.hbb(p, view);
  $this$dialog.lbb(tmp, view);
  return Unit_instance;
}
var calculateTodos$slambda$slambda$lambda$slambdaClass;
function calculateTodos$slambda$slambda$lambda$slambda() {
  if (calculateTodos$slambda$slambda$lambda$slambdaClass === VOID) {
    class $ {
      constructor($close) {
        this.tgx_1 = $close;
      }
      uao($completion) {
        this.tgx_1();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    calculateTodos$slambda$slambda$lambda$slambdaClass = $;
  }
  return calculateTodos$slambda$slambda$lambda$slambdaClass;
}
function calculateTodos$slambda$slambda$lambda$slambda_0($close) {
  var i = new (calculateTodos$slambda$slambda$lambda$slambda())($close);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $this$ButtonAction, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = awaitSuspending($this.ugx_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = awaitSuspending($this.ugx_1.vgj(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.k61_1 == null) {
      destination.v(element);
    }
  }
  tmp.fbw(new (MakePaymentInfoBandaidDialog())(tmp_0, new (PayRequested())(destination)));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, it, $completion) {
  if (!it)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = session.vfw().hfg_1.qfm(new (LineItemCompletionMessage())(VOID, $this.vgx_1.lf8(), $this.wgx_1.mf9_1, session.gfv_1, $this.vgx_1.tgj().zgj(), serializable(new (Accept())($this.xgx_1, session.wfw())), ''), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var calculateTodos$slambda$slambda$slambdaClass_0;
function calculateTodos$slambda$slambda$slambda_1() {
  if (calculateTodos$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_calculateTodos, $item, $proposal) {
        this.vgx_1 = $this_calculateTodos;
        this.wgx_1 = $item;
        this.xgx_1 = $proposal;
      }
      egk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambda$slambdaClass_0 = $;
  }
  return calculateTodos$slambda$slambda$slambdaClass_0;
}
function calculateTodos$slambda$slambda$slambda_2($this_calculateTodos, $item, $proposal) {
  var i = new (calculateTodos$slambda$slambda$slambda_1())($this_calculateTodos, $item, $proposal);
  var l = (it, $completion) => i.egk(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$withActionIcon, $completion) {
  var tmp = Companion_instance;
  var tmp_0 = awaitSuspending($this.agy_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp.egu($this.zgx_1, tmp_0, $this.agy_1.tgj(), VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.ygx_1, tmp_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, item, $completion) {
  var tmp = $this.bgy_1.vfw().gfg_1.jfm(item.e6k_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  var tmp_0 = (it) => it.e6k_1.equals(result.e6k_1);
  $this.bgy_1.ofv_1.eeo(tmp_0, (it) => result);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, confirmed, $completion) {
  if (confirmed) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_session();
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var session = tmp;
    var tmp_0 = first($this.cgy_1);
    var tmp_1 = repeatForScopeSets(tmp_0, calculateTodos$slambda$slambda$slambda$slambda_0(session), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var calculateTodos$slambda$slambda$slambda$slambdaClass;
function calculateTodos$slambda$slambda$slambda$slambda() {
  if (calculateTodos$slambda$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($session) {
        this.bgy_1 = $session;
      }
      dgy(item, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this, item), $completion);
      }
      s2(p1, $completion) {
        return this.dgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambda$slambda$slambdaClass = $;
  }
  return calculateTodos$slambda$slambda$slambda$slambdaClass;
}
function calculateTodos$slambda$slambda$slambda$slambda_0($session) {
  var i = new (calculateTodos$slambda$slambda$slambda$slambda())($session);
  var l = (item, $completion) => i.dgy(item, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambda$slambdaClass_1;
function calculateTodos$slambda$slambda$slambda_3() {
  if (calculateTodos$slambda$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor($items) {
        this.cgy_1 = $items;
      }
      egk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.egk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambda$slambdaClass_1 = $;
  }
  return calculateTodos$slambda$slambda$slambdaClass_1;
}
function calculateTodos$slambda$slambda$slambda_4($items) {
  var i = new (calculateTodos$slambda$slambda$slambda_3())($items);
  var l = (confirmed, $completion) => i.egk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $this$withActionIcon, $completion) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = $this.egy_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$0 = item.mf9_1;
    destination.v(tmp$ret$0);
  }
  var ids = toSet(destination);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ggy_1.dgt();
  var tmp = await_0(this_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList().w();
  var _iterator__ex2g4s_0 = tmp0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    if (ids.t1(element.y6g_1)) {
      destination_0.v(element);
    }
  }
  navigateOrDialog($this.fgy_1, new (ScopeSetReviewDialog())($this.egy_1, destination_0, $this.hgy_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_6($this, $this$ButtonAction, $completion) {
  var tmp = awaitSuspending($this.igy_1.lfy(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var project = tmp;
  var tmp0_elvis_lhs = project.s7b_1;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var tmp_1 = tmp_0;
  var tmp_2 = $this.igy_1.tgj();
  var tmp_3 = awaitSuspending($this.igy_1.ygk(), $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var tmp_4 = awaitSuspending($this.igy_1.hgl(), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  navigateOrDialog($this.jgy_1, new (ProjectCompleteRequestDetails())(project, tmp_1, tmp_2, tmp_3.d5c_1, tmp_4.v5i_1, $this.igy_1));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_7($this, $this$ButtonAction, $completion) {
  var info = new (ClientPaymentInfo())($this.kgy_1.lf8());
  var tmp = info.ngl($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = info.lgl_1;
  var tmp_1 = await_0(this_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$0 = tmp_1;
  tmp_0.zgd(new (CollectFundsThroughPhysicalCheckDialog())(tmp$ret$0.p9v_1, info));
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_8($this, $this$ButtonAction, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lgy_1.lfy();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  requestFundsDialog($this.lgy_1, tmp$ret$0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, $this$ButtonAction, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.mgy_1.lfy();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.mgy_1.vgm();
  var tmp_2 = await_0(this_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_2;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.mfy().equals(LineItemState_NotStarted_getInstance())) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$5 = item.jf9_1;
    destination_0.v(tmp$ret$5);
  }
  var tmp_3 = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.mgy_1.ngy();
  var tmp_4 = await_0(this_2, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp_5 = tmp_4;
  tmp.zgd(new (StartWorkItemsDialog())(tmp_1, tmp_3, tmp_5, calculateTodos$slambda$slambda$slambda_6()));
  return Unit_instance;
}
var calculateTodos$slambda$slambda$slambdaClass_2;
function calculateTodos$slambda$slambda$slambda_5() {
  if (calculateTodos$slambda$slambda$slambdaClass_2 === VOID) {
    class $ {
      ogy(selected, $completion) {
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!selected.i1()) {
          var tmp = JumpTo_getInstance().tg3_1;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = selected.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (element.h6k_1 == null) {
              destination.v(element);
            }
          }
          var tmp$ret$4;
          $l$block_0: {
            // Inline function 'kotlin.collections.minByOrNull' call
            var iterator = destination.m1();
            if (!iterator.n1()) {
              tmp$ret$4 = null;
              break $l$block_0;
            }
            var minElem = iterator.o1();
            if (!iterator.n1()) {
              tmp$ret$4 = minElem;
              break $l$block_0;
            }
            var minValue = minElem.m6k_1;
            do {
              var e = iterator.o1();
              var v = e.m6k_1;
              if (compareTo(minValue, v) > 0) {
                minElem = e;
                minValue = v;
              }
            }
             while (iterator.n1());
            tmp$ret$4 = minElem;
          }
          var tmp0_safe_receiver = tmp$ret$4;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e6k_1;
          var tmp_0;
          if (tmp1_elvis_lhs == null) {
            var tmp$ret$7;
            $l$block_1: {
              // Inline function 'kotlin.collections.minBy' call
              var iterator_0 = selected.m1();
              if (!iterator_0.n1())
                throw NoSuchElementException().y1();
              var minElem_0 = iterator_0.o1();
              if (!iterator_0.n1()) {
                tmp$ret$7 = minElem_0;
                break $l$block_1;
              }
              var minValue_0 = minElem_0.m6k_1;
              do {
                var e_0 = iterator_0.o1();
                var v_0 = e_0.m6k_1;
                if (compareTo(minValue_0, v_0) > 0) {
                  minElem_0 = e_0;
                  minValue_0 = v_0;
                }
              }
               while (iterator_0.n1());
              tmp$ret$7 = minElem_0;
            }
            tmp_0 = tmp$ret$7.e6k_1;
          } else {
            tmp_0 = tmp1_elvis_lhs;
          }
          tmp.bg5(tmp_0);
        }
      }
      s2(p1, $completion) {
        return this.ogy((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambda$slambdaClass_2 = $;
  }
  return calculateTodos$slambda$slambda$slambdaClass_2;
}
function calculateTodos$slambda$slambda$slambda_6() {
  var i = new (calculateTodos$slambda$slambda$slambda_5())();
  var l = (selected, $completion) => i.ogy(selected, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, $this$ButtonAction, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = RequestFinalCompletionDialog($this.pgy_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.zgd(tmp_0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, $this$ButtonAction, $completion) {
  var tmp = Companion_instance;
  var tmp_0 = awaitSuspending($this.sgy_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp.egu($this.rgy_1, tmp_0, $this.sgy_1.tgj(), VOID, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  navigateOrDialog($this.qgy_1, tmp_1);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_12($this, $this$ButtonAction, $completion) {
  var tmp = Companion_instance_0;
  var tmp_0 = awaitSuspending($this.ugy_1.lfy(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = awaitSuspending($this.ugy_1.egt(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (element.v67_1.equals($this.vgy_1.b63_1)) {
      destination.v(element);
    }
  }
  var tmp_2 = tmp.xgq(tmp_0, $this.vgy_1, destination, $this.ugy_1.tgj(), $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  navigateOrDialog($this.tgy_1, tmp_2);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_13($this, $this$rememberSuspending, $completion) {
  var allToDos = ArrayList().w();
  var tmp;
  if ($this.wgy_1.tgj().equals(ProjectLens_Preview_getInstance())) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.wgy_1.wgi_1;
    var tmp_0 = await_0(this_0, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = $this.wgy_1.lfy();
    var tmp_1 = await_0(this_1, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var tmp_2 = tmp_1.b7b_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = $this.wgy_1.lfy();
    var tmp_3 = await_0(this_2, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp$ret$2 = tmp_3;
    var tmp_4 = 'Accept Project: ' + tmp_2 + ' ' + MonetaryValue__toString_impl_xslc77(tmp$ret$2.w7b_1);
    var tmp_5 = color(ProjectState_WaitingApproval_getInstance());
    var tmp_6 = banners(calculateTodos$slambda$lambda);
    var tmp_7 = ButtonAction().fg1('Accept Project', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_0($this.wgy_1, $this.xgy_1));
    var tmp_8 = SecondaryButtonSemantic_getInstance();
    var tmp_9 = ButtonAction().fg1('Review Scope', tmp_8, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_2($this.wgy_1));
    var tmp_10 = SecondaryButtonSemantic_getInstance();
    calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_4, tmp_5, tmp_6, listOf([tmp_7, tmp_9, ButtonAction().fg1('Review Details', tmp_10, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_4())]));
  }
  if ($this.wgy_1.tgj().equals(ProjectLens_Customer_getInstance())) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.wgy_1.vgi_1;
    var tmp_11 = await_0(this_3, $completion);
    if (tmp_11 === get_COROUTINE_SUSPENDED())
      tmp_11 = yield tmp_11;
    if (tmp_11) {
      var tmp_12 = color(ProjectState_AwaitingFunding_getInstance());
      var tmp_13 = banners(calculateTodos$slambda$lambda_0);
      var tmp_14 = ButtonAction().fg1('Connect Bank Account', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_6($this.wgy_1));
      var tmp_15 = SecondaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Connect Bank Account', tmp_12, tmp_13, listOf([tmp_14, ButtonAction().fg1('More Info', tmp_15, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_8($this.xgy_1))]));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_4 = $this.wgy_1.ogi_1;
    var tmp_16 = await_0(this_4, $completion);
    if (tmp_16 === get_COROUTINE_SUSPENDED())
      tmp_16 = yield tmp_16;
    if (tmp_16) {
      var tmp_17 = color(ProjectState_AwaitingFunding_getInstance());
      var tmp_18 = banners(($this$banners) => {
        $this$banners.xfz('H-DepositEscrow-warn', ($this$warn) => {
          var project = $this$warn.daj($this.wgy_1.lfy());
          return trimIndent('\n                            <strong>Escrow Amount Due: ' + MonetaryValue__toString_impl_xslc77(project.r97()) + '<\/strong>\n                            \n                            Your contractor has requested ' + MonetaryValue__toString_impl_xslc77(project.z7b_1) + ' for this project. Click Send Escrow Funds for instructions to send a check or wire to Stoze. Be sure to include your project reference number (' + project.q97() + ') so we can credit your project correctly.\n\n                            Stoze holds your funds in an FDIC-insured escrow account. You are in full control to release payment draws as outlined in the project scope as the contractor completes work items. Once your project enters Pending Start, modifications and cancellations require an agreed upon change order.\n                            \n                            <i>Checks and wires typically take up to a week to be received and processed.<\/i>\n                        ');
        });
        return Unit_instance;
      });
      var tmp_19 = ButtonAction().fg1('Send Escrow Funds', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_10($this.wgy_1));
      var tmp_20 = SecondaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Funds Requested', tmp_17, tmp_18, listOf([tmp_19, ButtonAction().fg1('More Info', tmp_20, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_12())]));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = $this.wgy_1.agj_1;
    var tmp_21 = await_0(this_5, $completion);
    if (tmp_21 === get_COROUTINE_SUSPENDED())
      tmp_21 = yield tmp_21;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp_21.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var item = element.cf();
      var perms = element.df();
      var tmp_22 = 'Approve Work Item "' + item.nf9_1;
      var tmp_23 = color(ProjectState_InProgress_getInstance());
      var tmp0_safe_receiver = perms.o8y();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : acceptActionName(tmp0_safe_receiver, perms.m8x_1.h8x(ensureNotNull(perms.p8y()).e6h_1));
      var tmp_24 = tmp1_elvis_lhs == null ? 'ERROR' : tmp1_elvis_lhs;
      var tmp_25 = ButtonAction().fg1(tmp_24, VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_14(perms, $this.wgy_1, item));
      var tmp_26 = Companion_instance_2;
      var tmp_27 = SecondaryButtonSemantic_getInstance();
      var tmp_28 = calculateTodos$slambda$lambda_1(perms);
      var tmp_29 = tmp_26.og1('Review Request', tmp_27, VOID, VOID, tmp_28, VOID, calculateTodos$slambda$slambda_16($this.xgy_1, item, $this.wgy_1));
      var tmp_30 = SecondaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_22, tmp_23, VOID, listOf([tmp_25, tmp_29, ButtonAction().fg1('View Work Item', tmp_30, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_18($this.xgy_1, $this.wgy_1, item))]));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = $this.wgy_1.bgj_1;
    var tmp_31 = await_0(this_6, $completion);
    if (tmp_31 === get_COROUTINE_SUSPENDED())
      tmp_31 = yield tmp_31;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = tmp_31.d2().m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      // Inline function 'kotlin.collections.component1' call
      var scope = element_0.e2();
      // Inline function 'kotlin.collections.component2' call
      var items = element_0.f2();
      var tmp_32 = 'Approve Scope "' + scope.k7z_1 + '"';
      var tmp_33 = color(ProjectState_InProgress_getInstance());
      var tmp_34 = ButtonAction().fg1('Approve Work', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_20(items));
      var tmp_35 = Companion_instance_2;
      var tmp_36 = SecondaryButtonSemantic_getInstance();
      var tmp_37 = calculateTodos$slambda$lambda_2;
      var tmp_38 = tmp_35.og1('Review Request', tmp_36, VOID, VOID, tmp_37, VOID, calculateTodos$slambda$slambda_22(items, $this.xgy_1, $this.wgy_1, scope));
      var tmp_39 = SecondaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_32, tmp_33, VOID, listOf([tmp_34, tmp_38, ButtonAction().fg1('View Scope', tmp_39, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_24(scope))]));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_7 = $this.wgy_1.egj_1;
    var tmp_40 = await_0(this_7, $completion);
    if (tmp_40 === get_COROUTINE_SUSPENDED())
      tmp_40 = yield tmp_40;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = tmp_40.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      var tmp_41 = 'Review Changes From "' + element_1.q57_1 + '"';
      var tmp_42 = color(ProjectState_InProgress_getInstance());
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_41, tmp_42, VOID, listOf_0(ButtonAction().fg1('View Proposed', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_26(element_1))));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_8 = $this.wgy_1.fgj_1;
    var tmp_43 = await_0(this_8, $completion);
    if (tmp_43 === get_COROUTINE_SUSPENDED())
      tmp_43 = yield tmp_43;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = tmp_43.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var element_2 = _iterator__ex2g4s_2.o1();
      var tmp_44 = 'Review Draw ' + element_2.i6y_1;
      var tmp_45 = color(ProjectState_InProgress_getInstance());
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_44, tmp_45, VOID, listOf_0(ButtonAction().fg1('View Draw', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_28(element_2))));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_9 = $this.wgy_1.lgi_1;
    var tmp_46 = await_0(this_9, $completion);
    if (tmp_46 === get_COROUTINE_SUSPENDED())
      tmp_46 = yield tmp_46;
    if (tmp_46) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_10 = $this.wgy_1.hgi_1;
      var tmp_47 = await_0(this_10, $completion);
      if (tmp_47 === get_COROUTINE_SUSPENDED())
        tmp_47 = yield tmp_47;
      var fullyFunded = tmp_47;
      var tmp_48 = color(ProjectState_RequestingComplete_getInstance());
      var tmp_49 = banners(($this$banners) => {
        $this$banners.ag0('H-AcceptComplete-warn', "By clicking 'Accept & Pay Retention,' you confirm that all work has been completed to your satisfaction.\n\nThis action will release retention funds (if applicable) and mark the project as complete. For minor issues or adjustments, use the warranty phase to address them without delaying completion. Ensure all major concerns are resolved before proceeding.");
        var tmp;
        if (!fullyFunded) {
          $this$banners.bg0('H-AcceptComplete-FundingNeeded-danger', 'You cannot accept the project as complete until you deposit the remaining required funds.');
          tmp = Unit_instance;
        }
        return Unit_instance;
      });
      var tmp_50 = acceptFinalCompletion(Buttons_instance, $this.wgy_1, $this.xgy_1);
      var tmp_51 = SecondaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Accept Final Completion', tmp_48, tmp_49, listOf([tmp_50, ButtonAction().fg1('Review Request', tmp_51, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_30($this.wgy_1, $this.xgy_1))]));
    }
    var tmp_52;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_11 = $this.wgy_1.qgi_1;
    var tmp_53 = await_0(this_11, $completion);
    if (tmp_53 === get_COROUTINE_SUSPENDED())
      tmp_53 = yield tmp_53;
    if (tmp_53) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_12 = $this.wgy_1.rgi_1;
      var tmp_54 = await_0(this_12, $completion);
      if (tmp_54 === get_COROUTINE_SUSPENDED())
        tmp_54 = yield tmp_54;
      var tmp$ret$23 = tmp_54.y5r_1;
      tmp_52 = MonetaryValue__compareTo_impl_w7ul1r(tmp$ret$23, Companion_instance_1.m62(0)) > 0;
    } else {
      tmp_52 = false;
    }
    if (tmp_52) {
      var tmp_55 = color(ProjectState_Complete_getInstance());
      var tmp_56 = PrimaryButtonSemantic_getInstance();
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Funds Available', tmp_55, VOID, listOf_0(ButtonAction().fg1('View', tmp_56, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_32($this.wgy_1))));
    }
  }
  if ($this.wgy_1.tgj().equals(ProjectLens_Contractor_getInstance())) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_13 = $this.wgy_1.pgi_1;
    var tmp_57 = await_0(this_13, $completion);
    if (tmp_57 === get_COROUTINE_SUSPENDED())
      tmp_57 = yield tmp_57;
    if (tmp_57) {
      var tmp_58 = color(ProjectState_Accepted_getInstance());
      var tmp_59 = banners(calculateTodos$slambda$lambda_3);
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Funds Needed', tmp_58, tmp_59, listOf_0(ButtonAction().fg1('Request Funds', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_34($this.wgy_1))));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_14 = $this.wgy_1.cgj_1;
    var tmp_60 = await_0(this_14, $completion);
    if (tmp_60 === get_COROUTINE_SUSPENDED())
      tmp_60 = yield tmp_60;
    if (tmp_60.equals(ProjectState_PendingStart_getInstance())) {
      var tmp_61 = color(ProjectState_PendingStart_getInstance());
      var tmp_62 = banners(calculateTodos$slambda$lambda_4);
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Start Work', tmp_61, tmp_62, listOf_0(ButtonAction().fg1('Start Work Items', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_36($this.wgy_1))));
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_15 = $this.wgy_1.cgj_1;
    var tmp_63 = await_0(this_15, $completion);
    if (tmp_63 === get_COROUTINE_SUSPENDED())
      tmp_63 = yield tmp_63;
    if (tmp_63.equals(ProjectState_SubstantialCompletion_getInstance())) {
      var tmp_64 = color(ProjectState_SubstantialCompletion_getInstance());
      var tmp_65 = banners(calculateTodos$slambda$lambda_5);
      calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, 'Request Final Completion', tmp_64, tmp_65, listOf_0(ButtonAction().fg1('Request Complete', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_38($this.wgy_1))));
    }
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_16 = $this.wgy_1.igj_1;
  var tmp_66 = await_0(this_16, $completion);
  if (tmp_66 === get_COROUTINE_SUSPENDED())
    tmp_66 = yield tmp_66;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_3 = tmp_66.m1();
  while (_iterator__ex2g4s_3.n1()) {
    var element_3 = _iterator__ex2g4s_3.o1();
    var item_0 = element_3.cf();
    var perms_0 = element_3.df();
    var tmp_67 = 'Response Required for "' + item_0.nf9_1 + '"';
    var tmp_68 = color(ProjectState_InProgress_getInstance());
    var tmp_69 = banners(calculateTodos$slambda$lambda_6($this.wgy_1, item_0, perms_0));
    calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_67, tmp_68, tmp_69, listOf_0(ButtonAction().fg1('Review Concern', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_40($this.xgy_1, item_0, $this.wgy_1))));
  }
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_17 = $this.wgy_1.jgj_1;
  var tmp_70 = await_0(this_17, $completion);
  if (tmp_70 === get_COROUTINE_SUSPENDED())
    tmp_70 = yield tmp_70;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_4 = tmp_70.m1();
  while (_iterator__ex2g4s_4.n1()) {
    var element_4 = _iterator__ex2g4s_4.o1();
    var incident = element_4.cf();
    var tmp_71 = 'Response Required for "' + incident.h63_1.g9f_1 + '"';
    var tmp_72 = color(ProjectState_InProgress_getInstance());
    var tmp_73 = banners(calculateTodos$slambda$lambda_7($this.wgy_1, incident));
    calculateTodos$_anonymous_$_anonymous_$ToDo_mb3blb(allToDos, tmp_71, tmp_72, tmp_73, listOf_0(ButtonAction().fg1('Review Concern', VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda_42($this.xgy_1, $this.wgy_1, incident))));
  }
  return allToDos;
}
function calculateTodos$slambda$lambda($this$banners) {
  $this$banners.cg0('Review all project details and scope carefully. If needed, request edits or ask questions by sending your contractor a message. Changes after project acceptance requires both parties approval. Once updates are made the contractor will resend a project invite.');
  return Unit_instance;
}
var calculateTodos$slambda$slambdaClass;
function calculateTodos$slambda$slambda() {
  if (calculateTodos$slambda$slambdaClass === VOID) {
    class $ {
      constructor($this_calculateTodos, $$this$with) {
        this.pgx_1 = $this_calculateTodos;
        this.qgx_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass = $;
  }
  return calculateTodos$slambda$slambdaClass;
}
function calculateTodos$slambda$slambda_0($this_calculateTodos, $$this$with) {
  var i = new (calculateTodos$slambda$slambda())($this_calculateTodos, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_0;
function calculateTodos$slambda$slambda_1() {
  if (calculateTodos$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.ygy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        set_value(this.ygy_1.qgj_1, WorkSection_Scope_getInstance());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_0 = $;
  }
  return calculateTodos$slambda$slambdaClass_0;
}
function calculateTodos$slambda$slambda_2($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_1())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_1;
function calculateTodos$slambda$slambda_3() {
  if (calculateTodos$slambda$slambdaClass_1 === VOID) {
    class $ {
      yah($this$ButtonAction, $completion) {
        JumpTo_getInstance().kg3_1.rg4(VOID, Align_Start_getInstance());
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_1 = $;
  }
  return calculateTodos$slambda$slambdaClass_1;
}
function calculateTodos$slambda$slambda_4() {
  var i = new (calculateTodos$slambda$slambda_3())();
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_0($this$banners) {
  $this$banners.dg0('Connect your bank account now to be ready \u2014 money only moves into escrow protection when you approve a request.');
  return Unit_instance;
}
var calculateTodos$slambda$slambdaClass_2;
function calculateTodos$slambda$slambda_5() {
  if (calculateTodos$slambda$slambdaClass_2 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.zgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        tmp.zgd(new (SetupCustomerMethodDialog())(calculateTodos$slambda$slambda$slambda_0(this.zgy_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_2 = $;
  }
  return calculateTodos$slambda$slambdaClass_2;
}
function calculateTodos$slambda$slambda_6($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_5())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_3;
function calculateTodos$slambda$slambda_7() {
  if (calculateTodos$slambda$slambdaClass_3 === VOID) {
    class $ {
      constructor($$this$with) {
        this.agz_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        dialog(this.agz_1, VOID, calculateTodos$slambda$slambda$lambda);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_3 = $;
  }
  return calculateTodos$slambda$slambdaClass_3;
}
function calculateTodos$slambda$slambda_8($$this$with) {
  var i = new (calculateTodos$slambda$slambda_7())($$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_4;
function calculateTodos$slambda$slambda_9() {
  if (calculateTodos$slambda$slambdaClass_4 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.ugx_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_4 = $;
  }
  return calculateTodos$slambda$slambdaClass_4;
}
function calculateTodos$slambda$slambda_10($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_9())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_5;
function calculateTodos$slambda$slambda_11() {
  if (calculateTodos$slambda$slambdaClass_5 === VOID) {
    class $ {
      yah($this$ButtonAction, $completion) {
        get_dialogStack().zgd(GenericDialog().bgz("Contractor will submit for payment on an individual work item basis. After 14 days, funds will automatically release to the contractor for each work item approval request if no response is taken by the client. In the event of a performance or acceptance disagreement, Stoze will remain custodian of the funds until directed how to distribute from a joint resolution between client and contractor, or instructed by a binding arbitration decision.\n\nStoze advises clients to only accept change orders connected to the project when processed through Stoze by the contractor. Communicating about change orders in real time prevents unexpected pay requests by contractor at project closeout.\n\nStoze advises contractors to handle all cost changes through Stoze, but will be processed at the contractor's discretion. Any changes issued through Stoze that increase project costs may require additional funds for contractor to proceed with work. Changes resulting in a credit will remain in Stoze until project is completed and if a net credit remains, the balance will be returned to the client."));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_5 = $;
  }
  return calculateTodos$slambda$slambdaClass_5;
}
function calculateTodos$slambda$slambda_12() {
  var i = new (calculateTodos$slambda$slambda_11())();
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_6;
function calculateTodos$slambda$slambda_13() {
  if (calculateTodos$slambda$slambdaClass_6 === VOID) {
    class $ {
      constructor($perms, $this_calculateTodos, $item) {
        this.cgz_1 = $perms;
        this.dgz_1 = $this_calculateTodos;
        this.egz_1 = $item;
      }
      yah($this$ButtonAction, $completion) {
        var tmp0_elvis_lhs = this.cgz_1.n8y();
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var proposal = tmp;
        var text = acceptConfirmationText(proposal, this.cgz_1);
        var tmp_0 = get_dialogStack();
        tmp_0.zgd(new (GenericConfirmationDialog())(text.tw_1, text.uw_1, VOID, text.vw_1, VOID, VOID, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda$slambda_2(this.dgz_1, this.egz_1, proposal)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_6 = $;
  }
  return calculateTodos$slambda$slambdaClass_6;
}
function calculateTodos$slambda$slambda_14($perms, $this_calculateTodos, $item) {
  var i = new (calculateTodos$slambda$slambda_13())($perms, $this_calculateTodos, $item);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_1($perms) {
  return ($this$withActionIcon) => $perms.t8w() ? ActionImportance_Critical_getInstance() : ActionImportance_Important_getInstance();
}
var calculateTodos$slambda$slambdaClass_7;
function calculateTodos$slambda$slambda_15() {
  if (calculateTodos$slambda$slambdaClass_7 === VOID) {
    class $ {
      constructor($$this$with, $item, $this_calculateTodos) {
        this.ygx_1 = $$this$with;
        this.zgx_1 = $item;
        this.agy_1 = $this_calculateTodos;
      }
      yah($this$withActionIcon, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$withActionIcon), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_7 = $;
  }
  return calculateTodos$slambda$slambdaClass_7;
}
function calculateTodos$slambda$slambda_16($$this$with, $item, $this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_15())($$this$with, $item, $this_calculateTodos);
  var l = ($this$withActionIcon, $completion) => i.yah($this$withActionIcon, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_8;
function calculateTodos$slambda$slambda_17() {
  if (calculateTodos$slambda$slambdaClass_8 === VOID) {
    class $ {
      constructor($$this$with, $this_calculateTodos, $item) {
        this.fgz_1 = $$this$with;
        this.ggz_1 = $this_calculateTodos;
        this.hgz_1 = $item;
      }
      yah($this$ButtonAction, $completion) {
        if (get_viewIsNarrow(this.fgz_1)) {
          get_mainPageNavigator(this.fgz_1).fbw(new (LineItemDetailsPage())(this.ggz_1.lf8(), this.hgz_1.mf9_1, this.ggz_1.tgj(), this.ggz_1));
        } else {
          JumpTo_getInstance().tg3_1.bg5(this.hgz_1.mf9_1);
        }
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_8 = $;
  }
  return calculateTodos$slambda$slambdaClass_8;
}
function calculateTodos$slambda$slambda_18($$this$with, $this_calculateTodos, $item) {
  var i = new (calculateTodos$slambda$slambda_17())($$this$with, $this_calculateTodos, $item);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_9;
function calculateTodos$slambda$slambda_19() {
  if (calculateTodos$slambda$slambdaClass_9 === VOID) {
    class $ {
      constructor($items) {
        this.igz_1 = $items;
      }
      yah($this$ButtonAction, $completion) {
        var tmp = get_dialogStack();
        var tmp_0 = PrimaryButtonSemantic_getInstance();
        tmp.zgd(new (GenericConfirmationDialog())('Approve & Pay Work Items?', 'Approving work items releases funds to the contractor as payment. This will happen for each item in the scope set.', VOID, 'Approve & Pay', VOID, tmp_0, VOID, VOID, VOID, VOID, calculateTodos$slambda$slambda$slambda_4(this.igz_1)));
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_9 = $;
  }
  return calculateTodos$slambda$slambdaClass_9;
}
function calculateTodos$slambda$slambda_20($items) {
  var i = new (calculateTodos$slambda$slambda_19())($items);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_2($this$withActionIcon) {
  return ActionImportance_Important_getInstance();
}
var calculateTodos$slambda$slambdaClass_10;
function calculateTodos$slambda$slambda_21() {
  if (calculateTodos$slambda$slambdaClass_10 === VOID) {
    class $ {
      constructor($items, $$this$with, $this_calculateTodos, $scope) {
        this.egy_1 = $items;
        this.fgy_1 = $$this$with;
        this.ggy_1 = $this_calculateTodos;
        this.hgy_1 = $scope;
      }
      yah($this$withActionIcon, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this, $this$withActionIcon), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_10 = $;
  }
  return calculateTodos$slambda$slambdaClass_10;
}
function calculateTodos$slambda$slambda_22($items, $$this$with, $this_calculateTodos, $scope) {
  var i = new (calculateTodos$slambda$slambda_21())($items, $$this$with, $this_calculateTodos, $scope);
  var l = ($this$withActionIcon, $completion) => i.yah($this$withActionIcon, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_11;
function calculateTodos$slambda$slambda_23() {
  if (calculateTodos$slambda$slambdaClass_11 === VOID) {
    class $ {
      constructor($scope) {
        this.jgz_1 = $scope;
      }
      yah($this$ButtonAction, $completion) {
        JumpTo_getInstance().ug3_1.bg5(this.jgz_1.i7z_1);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_11 = $;
  }
  return calculateTodos$slambda$slambdaClass_11;
}
function calculateTodos$slambda$slambda_24($scope) {
  var i = new (calculateTodos$slambda$slambda_23())($scope);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_12;
function calculateTodos$slambda$slambda_25() {
  if (calculateTodos$slambda$slambdaClass_12 === VOID) {
    class $ {
      constructor($change) {
        this.kgz_1 = $change;
      }
      yah($this$ButtonAction, $completion) {
        JumpTo_getInstance().og3_1.bg5(this.kgz_1.o57_1);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_12 = $;
  }
  return calculateTodos$slambda$slambdaClass_12;
}
function calculateTodos$slambda$slambda_26($change) {
  var i = new (calculateTodos$slambda$slambda_25())($change);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_13;
function calculateTodos$slambda$slambda_27() {
  if (calculateTodos$slambda$slambdaClass_13 === VOID) {
    class $ {
      constructor($draw) {
        this.lgz_1 = $draw;
      }
      yah($this$ButtonAction, $completion) {
        JumpTo_getInstance().vg3_1.bg5(this.lgz_1.g6y_1);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_13 = $;
  }
  return calculateTodos$slambda$slambdaClass_13;
}
function calculateTodos$slambda$slambda_28($draw) {
  var i = new (calculateTodos$slambda$slambda_27())($draw);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_14;
function calculateTodos$slambda$slambda_29() {
  if (calculateTodos$slambda$slambdaClass_14 === VOID) {
    class $ {
      constructor($this_calculateTodos, $$this$with) {
        this.igy_1 = $this_calculateTodos;
        this.jgy_1 = $$this$with;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_14 = $;
  }
  return calculateTodos$slambda$slambdaClass_14;
}
function calculateTodos$slambda$slambda_30($this_calculateTodos, $$this$with) {
  var i = new (calculateTodos$slambda$slambda_29())($this_calculateTodos, $$this$with);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambda$slambdaClass_15;
function calculateTodos$slambda$slambda_31() {
  if (calculateTodos$slambda$slambdaClass_15 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.kgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_15 = $;
  }
  return calculateTodos$slambda$slambdaClass_15;
}
function calculateTodos$slambda$slambda_32($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_31())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_3($this$banners) {
  $this$banners.ag0('C-RequestFunding-warn', htmlKeyString('Be Aware', 'By requesting funds, you confirm readiness to start the project as outlined in the original scope. For any changes in cost or scope, ensure all updates are processed through Stoze to avoid payment issues or disputes.'));
  return Unit_instance;
}
var calculateTodos$slambda$slambdaClass_16;
function calculateTodos$slambda$slambda_33() {
  if (calculateTodos$slambda$slambdaClass_16 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.lgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_16 = $;
  }
  return calculateTodos$slambda$slambdaClass_16;
}
function calculateTodos$slambda$slambda_34($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_33())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_4($this$banners) {
  $this$banners.ag0('C-StartWork-warn', 'Starting within 10 days of receiving funds is highly advised. This sets a positive expectation for the client, reinforcing to them that you are prompt and professional.\n\nClick "Start Work Item" to start work when ordering materials and/or arriving on site. If ordering materials without simultaneous site arrival is part of starting work, then communicate to the client clearly, so they are not confused with an In Progress project status or concerned you aren\'t performing.');
  return Unit_instance;
}
var calculateTodos$slambda$slambdaClass_17;
function calculateTodos$slambda$slambda_35() {
  if (calculateTodos$slambda$slambdaClass_17 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.mgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_17 = $;
  }
  return calculateTodos$slambda$slambdaClass_17;
}
function calculateTodos$slambda$slambda_36($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_35())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_5($this$banners) {
  $this$banners.ag0('C-RequestProjectComplete', "Before requesting final completion:\n\n\u2022 Ensure all work is finished, and any remaining tasks, including 'required' punch list items, are documented or addressed.\n\u2022 Fix property damage, if applicable, and leave the workspace clean and organized.\n\u2022 Communicate warranty details and any remaining retention items clearly with the client.\n\u2022 Consider a final walk-through to resolve any outstanding concerns and build trust.\n\nReminder: The client can still file a dispute at this stage if concerns aren\u2019t resolved, so be thorough and professional in your approach.");
  return Unit_instance;
}
var calculateTodos$slambda$slambdaClass_18;
function calculateTodos$slambda$slambda_37() {
  if (calculateTodos$slambda$slambdaClass_18 === VOID) {
    class $ {
      constructor($this_calculateTodos) {
        this.pgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_18 = $;
  }
  return calculateTodos$slambda$slambdaClass_18;
}
function calculateTodos$slambda$slambda_38($this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_37())($this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_6($this_calculateTodos, $item, $perms) {
  return ($this$banners) => {
    var tmp;
    if ($this_calculateTodos.tgj().zgj()) {
      $this$banners.ag0('H-ResponseRequiredToDo-warn', 'The contractor has responded to your concern about ' + $item.nf9_1 + '. Review their response and take action' + (!$perms.t8w() && !$perms.x8w() ? '- the auto-approval timer is now counting down.' : '.'));
      tmp = Unit_instance;
    } else {
      $this$banners.ag0('C-ResponseRequiredToDo-warn', 'A concern has been raised about ' + $item.nf9_1 + '. Your payment is on hold - respond promptly to restart the approval timer.');
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var calculateTodos$slambda$slambdaClass_19;
function calculateTodos$slambda$slambda_39() {
  if (calculateTodos$slambda$slambdaClass_19 === VOID) {
    class $ {
      constructor($$this$with, $item, $this_calculateTodos) {
        this.qgy_1 = $$this$with;
        this.rgy_1 = $item;
        this.sgy_1 = $this_calculateTodos;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_19 = $;
  }
  return calculateTodos$slambda$slambdaClass_19;
}
function calculateTodos$slambda$slambda_40($$this$with, $item, $this_calculateTodos) {
  var i = new (calculateTodos$slambda$slambda_39())($$this$with, $item, $this_calculateTodos);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
function calculateTodos$slambda$lambda_7($this_calculateTodos, $incident) {
  return ($this$banners) => {
    var tmp;
    if ($this_calculateTodos.tgj().zgj()) {
      $this$banners.ag0('H-ResponseRequiredToDo-warn', 'The contractor has responded to your concern about ' + $incident.h63_1.g9f_1 + '. Review their response and take action.');
      tmp = Unit_instance;
    } else {
      $this$banners.ag0('C-ResponseRequiredToDo-warn', 'A concern has been raised about ' + $incident.h63_1.g9f_1 + '. Respond promptly to resolve the issue before it escalates.');
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
var calculateTodos$slambda$slambdaClass_20;
function calculateTodos$slambda$slambda_41() {
  if (calculateTodos$slambda$slambdaClass_20 === VOID) {
    class $ {
      constructor($$this$with, $this_calculateTodos, $incident) {
        this.tgy_1 = $$this$with;
        this.ugy_1 = $this_calculateTodos;
        this.vgy_1 = $incident;
      }
      yah($this$ButtonAction, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this, $this$ButtonAction), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambda$slambdaClass_20 = $;
  }
  return calculateTodos$slambda$slambdaClass_20;
}
function calculateTodos$slambda$slambda_42($$this$with, $this_calculateTodos, $incident) {
  var i = new (calculateTodos$slambda$slambda_41())($$this$with, $this_calculateTodos, $incident);
  var l = ($this$ButtonAction, $completion) => i.yah($this$ButtonAction, $completion);
  l.$arity = 1;
  return l;
}
var calculateTodos$slambdaClass;
function calculateTodos$slambda() {
  if (calculateTodos$slambdaClass === VOID) {
    class $ {
      constructor($this_calculateTodos, $$this$with) {
        this.wgy_1 = $this_calculateTodos;
        this.xgy_1 = $$this$with;
      }
      yah($this$rememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this, $this$rememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    calculateTodos$slambdaClass = $;
  }
  return calculateTodos$slambdaClass;
}
function calculateTodos$slambda_0($this_calculateTodos, $$this$with) {
  var i = new (calculateTodos$slambda())($this_calculateTodos, $$this$with);
  var l = ($this$rememberSuspending, $completion) => i.yah($this$rememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function projectToDos$lambda($this$title) {
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = 'All Caught Up!';
  var tmp = $this$title.vb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.hbu(tmp_0);
  $this$title.dbs(Align_Center_getInstance());
  return Unit_instance;
}
function projectToDos$lambda_0($this$forEachAnimated, todoAction) {
  var tmp = toDoSection($this$forEachAnimated, todoAction.mgx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachAnimated.pc());
  var tmp0_elvis_lhs = $this$forEachAnimated.ebb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachAnimated : tmp0_elvis_lhs;
  $this$forEachAnimated.gbb(p, view);
  view.zbm(true);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!todoAction.ngx_1.i1()) {
    renderBannersNonDismissable(view, todoAction.ngx_1);
  }
  // Inline function 'com.crowpay.views.theming.subTitle' call
  var content = todoAction.lgx_1;
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_0 = view_0.vb5_1;
  var tmp_1;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(content) === 0) {
    tmp_1 = '\xA0';
  } else {
    tmp_1 = content;
  }
  tmp_0.hbu(tmp_1);
  view.hbb(p_0, view_0);
  if (get_viewIsWide(view) || todoAction.ogx_1.p1() <= 2) {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_1 = view.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
    view.gbb(p_1, view_1);
    view_1.zbm(false);
    view_1.bb9(get_AppDimensions().kg2_1);
    var _iterator__ex2g4s = todoAction.ogx_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var action = _iterator__ex2g4s.o1();
      button(view_1, action);
    }
    view.hbb(p_1, view_1);
  } else {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_2 = view.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.gbb(p_2, view_2);
    view_2.zbm(false);
    view_2.bb9(get_AppDimensions().kg2_1);
    var _iterator__ex2g4s_0 = todoAction.ogx_1.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var action_0 = _iterator__ex2g4s_0.o1();
      var tmp_2 = get_expanding(view_2);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_3 = new (Button())(view_2.pc());
      var tmp0_elvis_lhs_3 = view_2.ebb_1;
      var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
      view_2.gbb(p_3, view_3);
      applyActionFormatting(view_3, action_0, false, true);
      view_2.hbb(p_3, view_3);
      view_2.lbb(tmp_2, view_3);
    }
    view.hbb(p_2, view_2);
  }
  $this$forEachAnimated.hbb(p, view);
  return $this$forEachAnimated.lbb(tmp, view);
}
//region block: exports
export {
  calculateTodos as calculateTodos38oklz6cvum2,
  projectToDos as projectToDos1k6no8sa36ugx,
};
//endregion

//# sourceMappingURL=projectToDos.mjs.map
